<script setup>
// Props.
defineProps({
  messageText: {
    type: String,
    required: true,
  },
  messageType: {
    type: String,
    required: true,
  },
});

// Model value.
const model = defineModel();

// Methods.
const closeMessage = () => {
  model.value = false;
};
</script>

<template>
  <!-- Use Drupal classes for styling purposes. -->
  <div
    class="messages"
    :class="`messages--${messageType}`"
    @click="closeMessage">
    <div class="messages__content">{{ messageText }}</div>
  </div>
</template>
